import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
// Sentry init MUST run before <App/> imports so its captureConsole
// hooks land before any log fires. Safe no-op when the DSN env var
// is empty.
import { Sentry, sentryEnabled } from "@/sentry";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// When Sentry is enabled, wrap the app in an ErrorBoundary so render
// errors (as opposed to async errors, which the SDK catches globally)
// are captured and the buyer sees a graceful "please retry" instead
// of a blank screen. When disabled, we render <App/> unwrapped so
// there is zero behavioural change from prior versions.
const Root = sentryEnabled
  ? () => (
      <Sentry.ErrorBoundary
        fallback={
          <div role="alert" style={{ padding: 24, fontFamily: "sans-serif" }}>
            <h1>Something went wrong.</h1>
            <p>Please refresh the page. If the issue persists, contact support.</p>
          </div>
        }
        showDialog={false}
      >
        <App />
      </Sentry.ErrorBoundary>
    )
  : App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Root />
    </QueryClientProvider>
  </React.StrictMode>,
);
